import Keycloak from './keycloak';

// @ts-ignore
const keycloak = new Keycloak({
  realm: window.location.hostname.split('.')[0],
  clientId: 'rightdata',
  url: "https://xp.rightcom.com",
});

// @ts-ignore
keycloak.run = function (name, data) {
  const myHeaders = new Headers();
  myHeaders.append('X-Parse-Application-Id', 'rightcomxp');
  myHeaders.append('X-Parse-REST-API-Key', 'restAPIKey');
  myHeaders.append('Content-Type', 'application/json');

  const raw = JSON.stringify({
    ...data,
    realm: keycloak.realm,
    token: keycloak.token,
  });

  const requestOptions: any = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow',
  };

  return keycloak.token
    ? fetch(
        'https://xp-api.rightcom.com/rest/functions/' + name,
        requestOptions,
      )
        .then((response) => response.json())
        .then((response) => response.result || response)
    : new Promise(() => console.log('you are not legged in'));
};

export default keycloak;
